import { getLanguage } from '@inter-ikea-storageone/shared/utils/i18nUtils';
import { useEffect } from 'react';
import useIsRtl from '@app/hooks/useIsRtl';

const useSetHtmlLanguageAttributes = () => {
  const isRtl = useIsRtl();

  useEffect(() => {
    const htmlElement = document.getElementsByTagName('html')[0];
    htmlElement.setAttribute('lang', getLanguage());
    htmlElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  });
};

export default useSetHtmlLanguageAttributes;
